import React, { useContext } from 'react'
import { AppContext } from 'common/Globals'
import { useSelector } from 'react-redux'
import { AppUrls } from 'common/AppUrls'
import { Redirect } from 'react-router'

export const useRedirections = ({ authRequired = false, path, disabled }) => {
    const { isUserAuthed } = useContext(AppContext)
    const { calls } = useSelector((state) => state.call)
    const { isMicrophonePermissionDenied, isInternetConnectionLost, isMultipleTabs } = useSelector(
        (state) => state.global
    )

    if (authRequired && !isUserAuthed) {
        return <Redirect to={{ pathname: AppUrls.login }} />
    }

    if (isMicrophonePermissionDenied && path !== AppUrls.microphonePermissionDenied) {
        if (!isInternetConnectionLost) {
            return <Redirect to={{ pathname: AppUrls.microphonePermissionDenied }} />
        }
    }

    if (!isMicrophonePermissionDenied && path === AppUrls.microphonePermissionDenied) {
        return <Redirect to={{ pathname: AppUrls.dialpad }} />
    }

    if (isInternetConnectionLost && path !== AppUrls.connectionLost) {
        return <Redirect to={{ pathname: AppUrls.connectionLost }} />
    }

    if (!isInternetConnectionLost && path === AppUrls.connectionLost) {
        return <Redirect to={{ pathname: AppUrls.dialpad }} />
    }

    if (!calls.length && path === AppUrls.call) {
        return <Redirect to={{ pathname: AppUrls.dialpad }} />
    }

    if (isMultipleTabs && path !== AppUrls.multipleTabsError) {
        return <Redirect to={{ pathname: AppUrls.multipleTabsError }} />
    }

    if (path === AppUrls.multipleTabsError && !isMultipleTabs) {
        return <Redirect to={{ pathname: AppUrls.dialpad }} />
    }

    if(disabled) {
        return <Redirect to={{ pathname: isUserAuthed ? AppUrls.dialpad : AppUrls.login}} />
    }
}
